import React from 'react';

type GapType = 'sm' | 'md';

const gapProperty: Record<GapType, string> = {
  sm: '8px',
  md: '24px',
};

type FontType = 'xs' | 's';

const fontSize: Record<FontType, string> = {
  xs: '16px',
  s: '18px',
};

type ColorType = 'black' | 'white';

const nameColor: Record<ColorType, string> = {
  black: '#000',
  white: '#fff',
};

export type PresenterProps = {
  name: string;
  avatarUrl: string;
  alt?: string;
  size?: number;
  gap?: GapType;
  font?: FontType;
  color?: ColorType;
  presenterLocation?: string;
  isPresenterLocationDisplayed?: boolean;
};

const Presenter: React.FC<PresenterProps> = ({
  name,
  avatarUrl,
  alt = name,
  gap = 'sm',
  font = 'xs',
  size = 40,
  color = 'black',
  presenterLocation = '',
  isPresenterLocationDisplayed = false,
}) => {
  const cssVars = {
    '--ab-size': `${size}px`,
    '--ab-gap': gapProperty[gap],
    '--font-size': fontSize[font],
    '--color': nameColor[color],
  } as React.CSSProperties;

  return (
    <div className="presenter" style={cssVars}>
      <img
        src={avatarUrl}
        alt={alt}
        className="presenter__img"
        width={size}
        height={size}
        loading="lazy"
        aria-hidden="true"
      />
      <div className="presenter__details">
        <span className="presenter__name">{name}</span>
        {isPresenterLocationDisplayed && (
          <span className="presenter__location">{presenterLocation}</span>
        )}
      </div>
    </div>
  );
};

export default Presenter;
